import {FaServer} from 'react-icons/fa'
import {CiBoxList} from 'react-icons/ci'
import {BiCodeAlt} from 'react-icons/bi'


const data = [
    {
        id: 1, icon: <CiBoxList />, title: 'Full Stack Development', desc: "Developing your website or app with robust, cutting-edge defenses is my priority, implementing security measures throughout the entire process to shield your business and users from attacks. Additionally, I guarantee full cross-device compatibility and beautiful presentation across all platforms, ensuring accessibility on mobile, tablet, and desktop."
    },
    {
        id: 2, icon: <BiCodeAlt />, title: 'Frontend Development', desc: "I ensure full cross-device compatibility and beautiful presentation across all platforms, and provide seamless backend integration, guaranteeing your product is accessible on mobile, tablet, and desktop without compromise."
    },
    {
        id: 3, icon: <FaServer/>, title: 'Backend Development', desc: "I implement cutting-edge security measures throughout the entire development process to shield your business and users from attacks, I ensure your website or app is developed with robust defenses to actively guard against modern threats."
    }    
]


export default data